export const CREATE_RESOURCE_SUCCESS="resource/CREATE_RESOURCE_SUCCESS";
export const CREATE_RESOURCE_FAILURE="resource/CREATE_RESOURCE_FAILURE";
export const GENERATE_ASSIGNMENT_QUESTIONS_SUCCESS="resource/GENERATE_ASSIGNMENT_QUESTIONS_SUCCESS";
export const GENERATE_ASSIGNMENT_QUESTIONS_FAILURE="resource/GENERATE_ASSIGNMENT_QUESTIONS_FAILURE";
export const HISTORY_ASSIGNMENT_SUCCESS="resource/HISTORY_ASSIGNMENT_SUCCESS";
export const HISTORY_ASSIGNMENT_FAILURE="resource/HISTORY_ASSIGNMENT_FAILURE";
export const CREATE_ALL_ASSIGNMENT_SUCCESS="resource/CREATE_ALL_ASSIGNMENT_SUCCESS";
export const CREATE_ALL_ASSIGNMENT_FAILURE="resource/CREATE_ALL_ASSIGNMENT_FAILURE";
export const DELETE_QUIZ_SUCCESS="resource/DELETE_QUIZ_SUCCESS";
export const DELETE_QUIZ_FAILURE="resource/DELETE_QUIZ_FAILURE";
export const UPDATE_QUIZ_SUCCESS="resource/UPDATE_QUIZ_SUCCESS";
export const UPDATE_QUIZ_FAILURE="resource/UPDATE_QUIZ_FAILURE";
export const ALL_ASSESSMENT_HISTORY_SUCCESS="resource/ALL_ASSESSMENT_HISTORY_SUCCESS";
export const ALL_ASSESSMENT_HISTORY_FAILURE="resource/ALL_ASSESSMENT_HISTORY_FAILURE";